export const isServiceCareLBeta = (productId: string | undefined, level: string | undefined) =>
    productId?.toLowerCase() === 'man-sku00000049' && level === '30.beta';
